import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

/**
 * Notifies the user when a new service-worker version is ready and offers
 * a one-tap reload. registerType: 'autoUpdate' in vite-plugin-pwa downloads
 * the new SW silently; we just surface the swap when it's installed.
 */
export default function ServiceWorkerUpdate() {
  const [needsRefresh, setNeedsRefresh] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

    // The vite-plugin-pwa auto-register injects a SW. Listen for the
    // "controllerchange" + "updatefound" events.
    let registration: ServiceWorkerRegistration | null = null;

    navigator.serviceWorker.ready.then((reg) => {
      registration = reg;
      reg.addEventListener("updatefound", () => {
        const newSW = reg.installing;
        if (!newSW) return;
        newSW.addEventListener("statechange", () => {
          if (newSW.state === "installed" && navigator.serviceWorker.controller) {
            setNeedsRefresh(true);
          }
        });
      });
    });

    // Periodically check for updates (every 60 min)
    const interval = setInterval(() => {
      registration?.update().catch(() => {});
    }, 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  const refresh = async () => {
    if ("serviceWorker" in navigator) {
      const reg = await navigator.serviceWorker.getRegistration();
      if (reg?.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });
    }
    window.location.reload();
  };

  if (!needsRefresh) return null;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50">
      <div className="bg-[#1a1a2e] border border-[#C9A96E]/40 rounded-xl px-4 py-3 shadow-xl flex items-center gap-3">
        <RefreshCw className="w-4 h-4 text-[#C9A96E]" />
        <span className="text-white text-sm">A new version of Time Miners is ready.</span>
        <button
          onClick={refresh}
          className="text-xs bg-[#C9A96E] hover:bg-[#d4b87a] text-black font-bold px-3 py-1.5 rounded-lg"
        >
          Refresh
        </button>
      </div>
    </div>
  );
}
